import { useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './mobile/MobileLayout';

interface AppLayoutProps {
  menuItems: (onMenuItemClick?: () => void) => ReactNode;
  breadcrumb?: string;
}

export const AppLayout = (props: AppLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile ? <MobileLayout {...props} /> : <DesktopLayout {...props} />;
};
